<!-- OK IE11 -->
<template>
  <form class="mb-4">
    <h1 class="h2 mb-3">
      Votre demande a bien été prise en compte.<br />
      Un conseiller vous recontactera prochainement
    </h1>
    <img
      src="@/assets/underline.png"
      alt="underline"
      class="underlineImg mb-5"
    />
  </form>
</template>

<script>
import objectHelper from "@/helpers/objectHelper";
import consentServices from "@/services/consentServices";
import userServices from "@/services/userServices";
import userConsentServices from "@/services/userConsentServices";
import { ConsentCustomContent } from "@/dto";

export default {
  name: "Login",
  emits: ["regenerate", "dataLoaded"],
  data: function () {
    return {
      consentData: new ConsentCustomContent(),
      currentUser: null,
      token: null,
      consentId: null,
    };
  },
  created: async function () {
    this.token = this.$route.query.token;
    this.consentId = this.$route.query.id;

    console.log(this.token);
    console.log(this.consentId);

    if (!objectHelper.isDefined(this.consentId) || this.consentId == 0) {
      this.consentId = 1;
    }

    if (objectHelper.isDefined(this.token)) {
      this.currentUser = await userServices.getUser(this.token, this.consentId);
    } else {
      this.$router.push({ name: "404" });
    }
    if (objectHelper.isDefined(this.currentUser)) {
      if (this.currentUser.isTokenUpToDate === false) {
        this.$router.push({ name: "TokenExpired" });
      }

      this.userConsent = await userConsentServices.getUserConsent(
        this.token,
        this.consentId
      );

      this.consentData = await consentServices.getConsentData(
        this.userConsent.consentId
      );

      await userConsentServices.AcceptUserConsent(this.token, this.consentId);

      this.$eventBus.emit("dataLoaded", this.consentData);
    } else {
      this.$router.push({ name: "404" });
    }
  },
  methods: {},
  computed: {},
};
</script>
<style lang="scss" child-component="Captcha">
.captcha {
  width: 287px !important;
}
</style>
<style lang="scss" scoped>
.captchaText {
  color: $blue-app;
}
.consentText {
  color: $blue-app;
  text-align: left;
}
.underlineImg {
  width: 635px;
}
a {
  &:hover {
    text-decoration: underline;
  }
  text-decoration: none;
}
svg {
  font-size: 60px;
  color: $blue-app;
}
.btn-secondary {
  width: 100%;
  &.active {
    background-color: $blue-app !important;
    color: white !important;
  }
}
</style>
